import React, { useCallback, useEffect, useMemo } from 'react'
import { cloneDeep, isEqual } from 'lodash'
import {
	ScheduleComponent, TimelineViews, TimelineMonth, Month,
	Inject, /* Resize, DragAndDrop, */
	ViewsDirective, ViewDirective,
} from '@syncfusion/ej2-react-schedule'
import { isNullOrUndefined } from '@syncfusion/ej2-base'

import { useInstData, useDelayTimer } from 'tyan/public/hooks'
import { Container } from 'tyan/public/newComponents'
import CellContextMenu from './CellContextMenu'
import PlanContextMenu from './PlanContextMenu'

// enableRipple(true);
const emptyArray = []
const emptyObject = {}

const innerStartTime = '_startTime'
const innerEndTime = '_endTime'
const innerSubject = '_subject'

const getDateOnly = date => new Date(date.getFullYear(), date.getMonth(), date.getDate())

// timeString 形如: 00:13
const getDateTime = (date, timeString) => {
	let [hour, min] = (timeString || '0').split(':')
	hour = parseInt(hour), hour = isNaN(hour) ? 0 : hour
	min = parseInt(min), min = isNaN(min) ? 0 : min
	return new Date(date.getFullYear(), date.getMonth(), date.getDate(), hour, min)
}

const Schedule = props => {
	let { me, setState, me: {
		state: {
			date, scheduleID, scheduleObj
		}
	} } = useInstData(props, () => ({
		state: {
			date: getDateOnly(new Date()),
			scheduleID: Tyan.getUuid()
		}
	}))

	let {
		scheduleProps: {
			readOnly,
			viewType = 'Month',			// 默认'Month'
			cssClass,
			rowAutoHeight = true, // 自动行高(多个重叠会推高)，默认true
			firstDayOfWeek = 0,
			date: dateProp, // 传入新增时将置选择日期
			interval = 1,
			startHour, endHour,
			planTextColor = 'white',	// plan文本颜色，默认'white'
			showHeaderBar = true,
			showTooltip = false,
			tooltipTemplate,
			field: {
				categoryID: categoryIDProp = 'PersonID',		// plans中的categoryID
				categoryText: categoryTextProp = 'PersonName', // categories中用于呈现的字段，可为回调
				categoryColor: categoryColorProp = 'color',
				categoryCssClassField: categoryCssClassFieldProp = 'class',
				categories: fieldCategoriesProp,
				// {
				// 	renderer: categoriesRenderer,			// 分类渲染函数
				// 	items: [		// 对象数组，有此配置，则categoryID, categoryText两个参数无效
				// 		{
				// 			name: 'devices',		// 分类名称，用于判断，必须
				// 			field: 'deviceID', 	// plans中对应的分类ID字段，除最后一级外，如plan数据无此字段不要配置
				// 			idField: 'id',		// id字段，默认为'id'
				// 			textField: 'name',		// 要呈现的文本字段
				// 		},
				// 		{
				// 			name: 'slots',
				// 			field: 'slotID',
				// 			idField: 'id',
				// 			textField: 'name',
				// 			groupIDField: 'deviceID'	// 上级id字段名称
				// 		}
				// 	]
				// },
				planStartTime: fieldPlanStartTime = 'StartTime',	// plans中的开始时间(int值)
				planEndTime: fieldPlanEndTime = 'EndTime', // plans中的结束时间(int值)
				planColor: fieldPlanColor = 'color',   // Plan用于呈现的颜色或回调
				planTextColor: fieldPlanTextColor,  // Plan用于呈现的文本颜色的字段名或回调，为空则使用上面的planTextColor
				planText: fieldPlanText = 'text'			// Plan用于呈现的文本或回调，形式为字段名或字段名数据 或返回结果为字符串或字符串数据
			} = emptyObject,
			categories: categoriesProp,
			plans: plansProp = emptyArray,
			unAvailable = emptyArray, // 不可时间段定义,数组的数组或返回所需数据的回调函数（参数为日期)，形始[['午休', '12:00', '13:00']]
			buttons = emptyArray,	// {text, icon, handler}	handler为回调函数, text, icon 为文本，所有参数初始化时有效
			/*		* contextMenu:形如{text, icon, disabled, cdt, handler, items}
					*   handler 与 items 二选一，items优先，即如果有items则handler无效
					*   handler, cdt 只能为回调函数
					*   items 为子项数组
					*   text, icon, disabled 均可为直接值或回调函数
					*   回调函数形式为 func(data)，其中data由onGetData生成 */
			planContextMenu, cellContextMenu,	// 右键菜单
			planTemplate,
			onDateChange,	// 选择日期改变时回调，参数(date:Date)
			onChangePlan, // 修改计划回调，修改内容为[categoryID]或时间, 参数:(newPlan, oldPlan) 
			onAddPlan, // 新增计划回调，参数:(plan) 内容含[categoryID]及时间
			onEditPlan, // 修改计划回调，参数:(plan) 原Plan信息
			onDeletePlan, // 删除计划回调，参数:(plan)原Plan信息
		}
	} = props

	// 重新计算fieldCategories
	me.fieldCategoriesProp = fieldCategoriesProp = isEqual(me.fieldCategoriesProp, fieldCategoriesProp) ? me.fieldCategoriesProp : fieldCategoriesProp
	const fieldCategories = useMemo(() => {
		// console.log('recal fieldCategories')
		let ret = fieldCategoriesProp ? cloneDeep(fieldCategoriesProp) : {
			items: [		// 对象数组，有此配置，则categoryID, categoryText两个参数无效
				{
					name: 'category',		// 分类名称，用于判断，必须
					field: categoryIDProp, 	// plans中对应的分类ID字段,除最后一级外，如plan数据无此字段不要配置
					idField: 'id',		// id字段，默认为'id'
					textField: categoryTextProp,		// 要呈现的文本字段
					colorField: categoryColorProp,		// 该分类事件的呈现颜色字段
					cssClassField: categoryCssClassFieldProp,	// 该分类事件的class字段
				}
			]
		}
		// 检查
		// 1、idField:或无则置为'id'
		// 2、field: 复制到_field，或无则置为`category${index}`
		ret.items.forEach((c, index) => {
			c.idField = c.idField || 'id'
			c._field = c.field || `_category${index}`
		})
		// console.log('recaled fieldCategories:', ret)
		return ret
	}, [fieldCategoriesProp, categoryIDProp, categoryTextProp, categoryColorProp, categoryCssClassFieldProp])

	// 重新计算categories
	me.categoriesProp = categoriesProp = isEqual(me.categoriesProp, categoriesProp) ? me.categoriesProp : categoriesProp
	const categories = useMemo(() => {
		// console.log('recal categories')
		let ret = categoriesProp ? cloneDeep(categoriesProp) : fieldCategories.items.map(fc => [])
		if (!Array.isArray(ret[0])) {
			ret = fieldCategories.items.map((fc, index) => index ? [] : ret)
		}
		// 计算每一个categories的父结点，及fieldCategory定义
		for (let index = ret.length - 1; index >= 0; index--) {
			const category = ret[index]
			const fieldCategory = fieldCategories.items[index]
			category.forEach(c => c._fieldCategory = fieldCategory)

			if (index > 0) {
				const { groupIDField } = fieldCategory
				const { idField: parentIDField } = fieldCategories.items[index - 1]

				const categoryParent = ret[index - 1]
				category.forEach(c => c._parent = categoryParent.find(parent => parent[parentIDField] == c[groupIDField]))
			}
		}
		// console.log('recaled categories:', ret)
		return ret
	}, [categoriesProp, fieldCategories])

	const resources = useMemo(() => fieldCategories.items.map((c, index) => ({
		idField: c.idField,
		field: c._field,
		name: c.name,
		textField: c.textField,
		colorField: c.colorField,
		cssClassField: c.cssClassField,
		groupIDField: c.groupIDField,
		allowMultiple: false,
		dataSource: categories[index]
	})), [categories])

	unAvailable = me.unAvailable = isEqual(unAvailable, me.unAvailable) ? me.unAvailable : unAvailable
	plansProp = me.plansProp = isEqual(plansProp, me.plansProp) ? me.plansProp : plansProp
	dateProp = dateProp ? (typeof dateProp === 'number' ? Ext.Date.utcToLocal(new Date(dateProp)) : dateProp) : undefined
	dateProp = dateProp ? new Date(dateProp.getFullYear(), dateProp.getMonth(), dateProp.getDate()) : undefined
	!isEqual(dateProp, me.dateProp) && (date = me.dateProp = dateProp, setState({ date: dateProp }))

	// 日期、categories、plansProp发生改变，重新生成plans
	const { plans, plansMap } = useMemo(() => {
		// console.log('gen plans plansMap')
		const newPlansMap = {}
		const newPlans = plansProp.filter(o => o).map(plan => {
			const ret = { ...plan }
			newPlansMap[plan.id] = plan
			ret[innerStartTime] = Ext.Date.utcToLocal(new Date(plan[fieldPlanStartTime]))
			ret[innerEndTime] = Ext.Date.utcToLocal(new Date(plan[fieldPlanEndTime]))
			const textArr = [].concat(typeof fieldPlanText === 'function' ? fieldPlanText(plan) : [].concat(fieldPlanText).map(field => plan[field]))
			const text = textArr.shift()
			ret[innerSubject] = `${text || ''}${textArr.length ? ` [${textArr.join(', ')}]` : ''}`
			return ret
		})
		// 根据unAvailable, categories, date生成Block
		const blocks = typeof unAvailable === 'function' ? unAvailable(date) : unAvailable
		blocks.forEach(([text, start, end], blockIndex) => {
			const startTime = getDateTime(date, start)
			const endTime = getDateTime(date, end)
			categories[categories.length - 1].forEach((category, index) => {
				const plan = {
					id: `block_${blockIndex}_${index}`,
					[innerSubject]: text || '',
					// text,
					[category._fieldCategory._field]: category[category._fieldCategory.idField],
					[innerStartTime]: startTime,
					[innerEndTime]: endTime,
					IsBlock: true
				}
				newPlans.push(plan)
			})
		})
		// 置所有_field值
		const { _field, idField } = fieldCategories.items[fieldCategories.items.length - 1]
		newPlans.forEach(plan => {
			let category = categories[categories.length - 1].find(category => category[idField] == plan[_field])
			while (category._parent) {
				category = category._parent
				plan[category._fieldCategory._field] = category[category._fieldCategory.idField]
			}
		})

		// console.log('newPlans:', newPlans)

		return { plans: newPlans, plansMap: newPlansMap }
	}, [unAvailable, date, categories, plansProp])

	const getNewPlan = useCallback(data => {
		const plan = {
			[fieldPlanStartTime]: Ext.Date.localToUtc(data[innerStartTime]).valueOf(),
			[fieldPlanEndTime]: Ext.Date.localToUtc(data[innerEndTime]).valueOf()
		}

		//  重新计算分类信息
		const { _field, idField } = fieldCategories.items[fieldCategories.items.length - 1]
		if (!isNullOrUndefined(data[_field])) {
			plan[_field] = data[_field]
			let category = categories[categories.length - 1].find(category => category[idField] == plan[_field])
			while (category._parent) {
				category = category._parent
				category._fieldCategory.field && (plan[category._fieldCategory.field] = category[category._fieldCategory.idField])
			}
		}
		// console.log('new plan:', plan)

		return plan
	}, [categories])

	const scheduleHandlers = {
		actionBegin: args => {
			const { requestType, data } = args
			if (requestType === 'eventChange') {
				args.cancel = true;
				if (readOnly || !me.scheduleObj.isSlotAvailable(data)) return
				const newData = { ...plansMap[data.id], ...getNewPlan(data) }

				onChangePlan && onChangePlan(newData, plansMap[data.id])
			} else if (requestType === 'toolbarItemRendering') {
				args.items[3].align = 'Left'
				buttons.filter(({ cdt }) => !cdt || cdt()).forEach(({ text, icon, handler }) => {
					const item = { text, click: () => handler && handler(me.state.date), align: 'right' }
					icon && (item.prefixIcon = `t-fa fa-${icon}`)
					args.items.push(item)
				})
			}
		},
		eventClick: args => {
			args.cancel = true
		},
		navigating: args => {
			if (args.action != 'date') return
			const currentDate = getDateOnly(args.currentDate)
			if (isEqual(date, currentDate)) return
			setState({ date: currentDate })
			onDateChange && onDateChange(args.currentDate)
		},
		popupOpen: args => {
			const { type, data } = args;
			if (type === 'Editor') {
				args.cancel = true
				if (readOnly) return

				const callback = data.id ? onEditPlan : onAddPlan
				// let newData = undefined
				callback && callback(data.id ? plansMap[data.id] : getNewPlan(data))
			} else if (type === 'QuickInfo') {
				args.cancel = true
				if (readOnly) return
				if (me.scheduleObj.getSelectedElements().length > 1) {
					me.scheduleObj.removeSelectedClass()
					me.scheduleObj.isSlotAvailable(data) && onAddPlan && onAddPlan(getNewPlan(data))
				}
			} else if (type === 'DeleteAlert') {
				args.cancel = true
				if (readOnly) return
				onDeletePlan && onDeletePlan(plansMap[data.id])
			}
		},
		eventRendered: args => {
			const { data, type, element: { style: elementStyle } } = args
			if (type === 'event') {
				elementStyle.backgroundColor = typeof fieldPlanColor === 'function' ? fieldPlanColor(data) : data[fieldPlanColor]
				elementStyle.color = fieldPlanTextColor
					? (typeof fieldPlanTextColor === 'function' ? fieldPlanTextColor(data) : data[fieldPlanTextColor])
					: planTextColor
			}
		},
		tooltipOpen: ({ content }) => {
			content.classList.remove('e-tooltip-hidden')
		}

	}

	const eventSettings = {
		dataSource: plans,
		template: planTemplate,
		enableTooltip: showTooltip,
		tooltipTemplate,
		fields: {
			id: 'id',
			startTime: { name: innerStartTime },
			endTime: { name: innerEndTime },
			subject: { name: innerSubject },
			isAllDay: { name: 'isAllDay' }
		}
	}

	const resourceHeaderTemplate = useCallback(({ resource, resourceData }) => {
		// console.log('source header template')
		const { renderer } = fieldCategories
		const { textField } = resource
		const ret = renderer ? renderer(resource, resourceData) : typeof textField === 'function' ? textField(resourceData) : resourceData[textField]
		return ret
	}, [fieldCategories])

	const scheduleProps = {}
	!isNullOrUndefined(readOnly) && (scheduleProps.readOnly = readOnly)
	!isNullOrUndefined(startHour) && (scheduleProps.startHour = startHour)
	!isNullOrUndefined(endHour) && (scheduleProps.endHour = endHour)

	// console.log('render Persons:', persons)
	// console.log('render plans:', plans, plansMap)

	// 初始时如果未传入date，则调用dateChange
	useEffect(() => {
		!dateProp && onDateChange && onDateChange(date)
		return () => {
			me.scheduleObj && me.scheduleObj.destroy()
		}
	}, [])

	useEffect(() => {
		me.scheduleObj.showHeaderBar = false
		me.scheduleObj.showHeaderBar = true
	})

	const { doDelay } = useDelayTimer(200)
	const handleContainerResize = (container, width, height, oldWidth, oldHeight) => {
		// console.log('container resize:', width, height, oldWidth, oldHeight)
		// console.log('container resize:', width, oldWidth, height, oldHeight)
		// me.scheduleObj && height != oldHeight && (/* console.log('doresize:', height, oldHeight),  */doDelay(() => (me.scheduleObj.height = height, me.scheduleObj.height = '100%')))
		me.scheduleObj && (doDelay(() => me.scheduleObj.refresh()))
		// me.scheduleObj && (doDelay(() => me.scheduleObj.height = height))
	}

	const handleCellContextData = data => getNewPlan(data)

	const handlePlanContextData = data => plansMap[data.id]

	return <Container id={`wraaper-${scheduleID}`} className='t-schedule-wrapper' onResize={handleContainerResize}/* style={{ flex: 1 }}  */
		style={{ /* margin: '5px',  *//* padding: '5px',  */width: '100%', height: '100%', maxHeight: '100%', maxWidth: '100%' }}
	>
		{plans && <>
			<ScheduleComponent id={`scheduleComponent-${scheduleID}`} cssClass={`t-schedule${cssClass ? ` ${cssClass}` : ''}`}
				ref={schedule => schedule && scheduleObj !== schedule && (/* window.schedule =  */me.scheduleObj = schedule, setState({ scheduleObj: schedule }))}
				// ref={schedule => schedule && (/* window.schedule =  */me.scheduleObj = schedule)}
				// width='100%' height={100}
				width='100%' height='100%'
				showHeaderBar={showHeaderBar}
				// width='calc(100% - 6px)' height='calc(100% - 6px)'
				selectedDate={date}
				workHours={{ start: '00:00', end: '23:59' }}
				firstDayOfWeek={firstDayOfWeek}
				{...scheduleProps}
				rowAutoHeight={rowAutoHeight}
				eventSettings={eventSettings}
				// showTimeIndicator={false}
				{...scheduleHandlers}
				resourceHeaderTemplate={resourceHeaderTemplate}
				// group={{ enableCompactView: false, resources: fieldCategories.items.map(c => c.name) }}
				quickInfoOnSelectionEnd={true}
				resources={resources}
			>
				<ViewsDirective>
					<ViewDirective option={viewType} interval={interval} />
				</ViewsDirective>
				<Inject services={[TimelineViews, TimelineMonth, Month/* , Resize, DragAndDrop */]} />
			</ScheduleComponent>
			{cellContextMenu && <CellContextMenu schedule={scheduleObj} contextMenu={cellContextMenu} onGetData={handleCellContextData} /> || null}
			{planContextMenu && <PlanContextMenu schedule={scheduleObj} contextMenu={planContextMenu} onGetData={handlePlanContextData} /> || null}
		</> || null}
	</Container>
}

export default Schedule